import { createContext, useContext, useState, useEffect } from "react";

const LibCategoryContext = createContext();

export function LibCategoryProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [libCategory, setLibCategory] = useState("");


    useEffect(() => {

        async function fetchLibCategory() {
            setLoading(true);
            try {
                let page = 1;
                let allResults = [];
                let hasMorePages = true;

                while (hasMorePages) {
                    const categoryData = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/library/categories?page=${page}`, {
                        method: "GET",
                        headers: {
                            "accept": "*/*"
                        },
                        body: JSON.stringify()
                    });
                    const response = await categoryData.json();

                    if (response.data?.result) {
                        allResults = [...allResults, ...response.data.result];
                        if (page >= response.data.paginationInfo.totalPagesCount) {
                            hasMorePages = false;
                        }
                    } else {
                        hasMorePages = false;
                    }
                    page++;
                }
                setLibCategory(allResults);
            } catch (error) {
                console.error("Error fetching all categories:", error);
            }
        };


        fetchLibCategory();
    }, [currentPage]);

    return (
        <LibCategoryContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage, libCategory
            }}>
            {children}
        </LibCategoryContext.Provider>
    );
}

export function useLibCategory() {
    return useContext(LibCategoryContext);
}